import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, Mail, Pencil, Settings, Shield, Users, X } from "lucide-react";
import { RoleBadge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card";
export const OrganizationDetailsCard = ({ organizationName, organizationEmail, membersCount, canViewMembers, canModifyUsers, currentUserRole, isViewingOwnOrg, isEditingName, editedName, nameSaveError, isUpdatingName, onEditedNameChange, onStartEditName, onCancelEditName, onSaveName })=>{
    return /*#__PURE__*/ _jsx(Card, {
        title: "Organization Details",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "space-y-4",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Settings, {
                                    className: "mr-2 h-5 w-5 text-gray-400"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-500",
                                    children: "Organization Name"
                                })
                            ]
                        }),
                        isEditingName ? /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    type: "text",
                                    value: editedName,
                                    onChange: (event)=>onEditedNameChange(event.target.value),
                                    className: "rounded border border-gray-300 px-2 py-1 text-sm font-medium text-gray-900",
                                    autoFocus: true,
                                    disabled: isUpdatingName,
                                    onKeyDown: (event)=>{
                                        if (event.key === "Enter") {
                                            onSaveName();
                                        } else if (event.key === "Escape") {
                                            onCancelEditName();
                                        }
                                    }
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: onSaveName,
                                    disabled: isUpdatingName || !editedName.trim(),
                                    className: "text-green-600 hover:text-green-800 disabled:cursor-not-allowed disabled:opacity-50",
                                    title: "Save",
                                    children: /*#__PURE__*/ _jsx(Check, {
                                        className: "h-4 w-4"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("button", {
                                    onClick: onCancelEditName,
                                    disabled: isUpdatingName,
                                    className: "text-red-600 hover:text-red-800 disabled:cursor-not-allowed disabled:opacity-50",
                                    title: "Cancel",
                                    children: /*#__PURE__*/ _jsx(X, {
                                        className: "h-4 w-4"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "max-w-[250px] truncate text-sm font-medium text-gray-900",
                                    title: organizationName,
                                    children: organizationName
                                }),
                                canModifyUsers && /*#__PURE__*/ _jsx("button", {
                                    onClick: onStartEditName,
                                    className: "flex-shrink-0 text-gray-400 hover:text-gray-600",
                                    title: "Edit organization name",
                                    children: /*#__PURE__*/ _jsx(Pencil, {
                                        className: "h-4 w-4"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                isEditingName && nameSaveError && /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-red-600",
                    children: nameSaveError
                }),
                isEditingName && !nameSaveError && isUpdatingName && /*#__PURE__*/ _jsx("p", {
                    className: "text-sm text-gray-500",
                    children: "Saving..."
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Mail, {
                                    className: "mr-2 h-5 w-5 text-gray-400"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-500",
                                    children: "Contact Email"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-sm font-medium text-gray-900",
                            children: organizationEmail
                        })
                    ]
                }),
                canViewMembers && /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Users, {
                                    className: "mr-2 h-5 w-5 text-gray-400"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-500",
                                    children: "Team Members"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-sm font-medium text-gray-900",
                            children: membersCount
                        })
                    ]
                }),
                currentUserRole && isViewingOwnOrg && /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ _jsx(Shield, {
                                    className: "mr-2 h-5 w-5 text-gray-400"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text-sm text-gray-500",
                                    children: "Your Role"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(RoleBadge, {
                            role: currentUserRole
                        })
                    ]
                })
            ]
        })
    });
};
export default OrganizationDetailsCard;
